import * as React from 'react'
import { BaseIconProps } from '../../../types'

function SvgIHerbLeaf({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.78 2.555s.857 7.04-.816 11.583c-2.651 7.194-9.086 5.37-11.447 3.765.24-.234 2.294-3.132 2.294-3.132s5.988 1.755 6.06.16c.065-1.478-5.822-.653-5.822-.653l1.823-2.23s4.5.837 4.5-.205c0-1.604-4.202-.468-4.202-.468l1.957-2.32s2.546.567 2.804-.391c.303-1.123-2.434-.131-2.434-.131s3.252-2.556 2.52-3.332c-.883-.936-2.863 2.91-2.863 2.91s.229-2.404-.664-2.35c-1.17.072.082 2.88.082 2.88l-1.79 2.29s.55-4.423-1.152-3.453c-.836.477 1.111 3.071.621 3.83-.49.76-1.862 2.445-1.862 2.445s.13-1.237-.1-2.36c-.228-1.123-.987-2.477-1.469-2.067-.971.826 1.807 3.561.882 5.054-.596.962-1.554 2.04-2.126 2.79-1.838-.972-4.954-7.657-.117-11.092 6.053-4.3 13.322-3.523 13.322-3.523zM5.343 19.323c1.32.039 2.657-1.397 3.234-2.154.147.136.717.582.94.734-1.442 2.337-3.042 3.802-5.013 3.574-1.742-.202-2.31-.939-2.473-1.827-.13-.71.156-1.341.899-1.42 1.357-.145.859 1.047 2.413 1.093z"
        fill={color}
      />
    </svg>
  )
}

export default SvgIHerbLeaf
